const env = process.env.VUE_APP_URL


const EnvConfig = {
  // 开发环境
  development: {
    baseUrl: 'http://192.168.0.168:8180/energy-wx',
  },
  chongqing: {
    baseUrl: 'http://st.cqifs.edu.cn',
  },
  production: {
    baseUrl: 'http://10.10.0.177:8185',
  }
}




export default EnvConfig[env]